export default __webpack_public_path__ + "static/media/social_graph_example.d791e235.png";